var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"font-light text-3xl text-black flex justify-center p-14"},[_vm._v("-Müco Online Menu-")])])}]

export { render, staticRenderFns }